import {FC} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

type props2 = {
  mensaje: string
  tipo: string
}

const IAlerta: FC<props2> = ({mensaje, tipo}) => {
  return (
    <div className='row mt-4'>
      <div className={clsx('alert alert-dismissible d-flex flex-column flex-sm-row p-5 ', tipo)}>
        <span className='svg-icon svg-icon-2hx svg-icon-light mt-1'>
          <FontAwesomeIcon icon={'exclamation'} />
        </span>
        <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
          <h5 className='mb-1 text-white'>Error</h5>
          <span>{mensaje}</span>
        </div>

        <button
          type='button'
          className='position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto d-none'
          data-bs-dismiss='alert'
        >
          <span className='svg-icon svg-icon-2x svg-icon-light'>
            <FontAwesomeIcon icon={'times'} />
          </span>
        </button>
      </div>
    </div>
  )
}

export {IAlerta}
